import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import { Tooltip } from '@clds/tooltip';
import { Button, LinkButton } from '@clds/button';
import { getAnalyticsProp } from '@cld/analytics';
import { useAccessibility } from '../../context/accessibility/accessibilityContext';
import { PrimaryMenuItemProps, ItemButtonType, PrimaryMenuItemCommonTypes, PrimaryMenuItemCommonRef } from './PrimaryMenu.types';

export const PrimaryMenuItemCommon = forwardRef<PrimaryMenuItemCommonRef, PrimaryMenuItemCommonTypes>(
  ({ type = 'button', analyticsMessage, analyticsAction, children, ...rest }, ref) => {
    const analyticsProp = getAnalyticsProp(analyticsMessage, analyticsAction);
    const ItemButton = (type === 'link' ? LinkButton : Button) as ForwardRefExoticComponent<
      PropsWithoutRef<ItemButtonType> & RefAttributes<PrimaryMenuItemCommonRef>
    >;
    const { isDisabled } = useAccessibility();

    return (
      <ItemButton
        ref={ref}
        tone="plain"
        variant="secondary"
        disabled={isDisabled}
        tabIndex={isDisabled ? -1 : 0}
        leftSlot={children}
        {...analyticsProp}
        {...rest}
      />
    );
  }
);

export const PrimaryMenuItem = forwardRef<PrimaryMenuItemCommonRef, PrimaryMenuItemProps>(
  ({ type, tooltipPlacement = 'right', tooltipTitle, analyticsMessage, analyticsAction, children, ...rest }, ref) => (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
      <PrimaryMenuItemCommon ref={ref} type={type} analyticsMessage={analyticsMessage} analyticsAction={analyticsAction} children={children} {...rest} />
    </Tooltip>
  )
);

export const PrimaryMenuItemMobile = PrimaryMenuItemCommon;
